(function($){

  function FAQ(){
    this.ns = 'rb-faq';
    this.$el = $('.rb-faq');
    this.$loading = this.$('loading'); 
    this.$content = this.$('content');
    this.$search = this.$('search');
    this.$results = this.$('search-results');
    this.hash = null;
    
    this.questions = [];
    this.ids = {};
    
    this.process();
    this.listen();
    
    this.$loading.remove();
    this.$search.show();
    this.$content.show();
    
    this.onHashChange();
  }

  $.extend( FAQ.prototype, {
    
    $ : function( selector ){
      return this.$el.find( '.'+this.ns+'__'+selector );
    },

    process : function(){
	
      var questions = this.questions;
      var ids = this.ids;
      
      this.$content.find('h4').each(function(){

        var $h4 = $(this).addClass('rb-faq__q');
        var $a = $('<div />').addClass('rb-faq__a');
        var $cur = $h4;
        var cur;
        var $anchor = $('<a />');
        
        $anchor.html( $h4.html() );
        $h4.empty().append($anchor);
        
        
        var html = '';
        var node = this.nextSibling;
        while( node ){
          if( node.tagName && ~['H2','H3','H4'].indexOf( node.tagName.toUpperCase() ) ){
            break;
          }
          if( node.nodeType == Node.TEXT_NODE ){
            html+=node.wholeText;
          }
          else {
            html+=node.outerHTML;
          }
		  cur = node;
          node = node.nextSibling
          cur.parentNode.removeChild(cur);
        }
          
        
        $cur = $h4;
        while( ($cur = $cur.prev()).length && !$cur.is('h3') );
        
        var section = $cur.is('h3') ? $cur.text() : '';
        
        var title = $h4.text().replace(/(^\s+|\s+$)/g, '');
//        var id = title.toLowerCase().replace(/[^\sa-z]/g, '').replace(/[\s]/g, '-');
        var id = title;
        
        console.log('id' + id);
        $anchor.attr('href', '#!'+id);
        
        
        $a.html( '<div class="rb-faq__a-content">'+html+'</div>' );
        
        var $qa = $('<div />').addClass('rb-faq__qa').attr('id', id);
        
        $qa.insertBefore($h4);
        $qa.append( $h4 ).append( $a );
        
        ids[id] = questions.length;
        console.log(id);
        console.log($qa);
        console.log(section);
        console.log(questions.length +"$$");
        questions.push({
          i: questions.length,
          id: id,
          node: $qa,
          title: title,
          section: section
        });
        
        
      });
      
      this.index = lunr(function(){
        this.ref('i');
        this.field('title');
        
        questions.forEach(function(doc, i){
          this.add(doc);
        },this);
      });
    },
    
    listen : function(){
      this.$content.find('.'+this.ns+'__q a').on('click', $.proxy(this.onClickQuestion, this));
      this.$search.find('input')
      	.on('keyup change', $.proxy(this.onSearchInput, this))
      	.on('keydown', $.proxy(this.onResultsNavigate, this))
	    .on('focus', $.proxy(this.onSearchInput, this))
      	.on('blur', $.proxy(this.hideResults, this));
      this.$search.on('mouseenter', 'li', $.proxy(this.onResultMouseenter, this));
      this.$search.on('mouseleave', 'li', $.proxy(this.onResultMouseleave, this));
      this.$search.on('mouseup', 'li', $.proxy(this.onResultClick, this));
      $(window).on('hashchange', $.proxy(this.onHashChange, this));
    },
    
    onClickQuestion : function(e){
      
      e.stopImmediatePropagation();

      var $q = $(e.currentTarget);
      var $qa = $q.parents('.'+this.ns+'__qa');
      var $a = $qa.find('.'+this.ns+'__a');
      var isOpen = $qa.hasClass('-open');
      
      this.hash = $q.attr('href');
      
      
      $a.css('height', $a.height());
      
      $a.animate({
        height: isOpen ? 0 : $a[0].scrollHeight
      }, 250, function(){
        if( !isOpen ){
          $a.css('height', 'auto');
        }
      });
      
      $qa.toggleClass('-open');
      
        
    },
    
    onSearchInput : function(e){
      
      if( e.type === 'keyup' && ~[9,38,40,13].indexOf( e.keyCode ) ){
        return;
      }
      var questions = this.questions;
      var $input = $(e.currentTarget);
      var term = $input.val();
      var $results = $input.next('.'+this.ns+'__search-results');
      
      var results = term && term.length > 2 ? this.index.search( term+' '+term+'*' ) : [];
      
///      console.log(results);
///      console.log(term);

      if( !results.length ){
        $results.hide();
      }
      else {
        $results.show();
        $results.empty();
        $.each(results, function(i,r){
          var q = questions[r.ref];
          $('<li />').html( q.title ).data('ref', r.ref ).appendTo($results);
        });
      }
    },
    
    onResultsNavigate : function(e){
      
      var questions = this.questions;
      var $input = $(e.currentTarget);
      var term = $input.val();
      var $results = this.$results;
      
      if( $results.find('li').length && ~[9,38,40,13].indexOf( e.keyCode ) ){

        var ignore = false;
        var $active = $results.find('li.-selected');

        if( e.keyCode == 38 || (e.keyCode == 9 && e.shiftKey) && $active.length ){
          $active.removeClass('-selected');
          if( !$active.prev().length ){
            $results.find('li').last().addClass('-selected');
          }
          else {
            $active.prev().addClass('-selected');
          }

        }
        else if( e.keyCode == 40 || (e.keyCode == 9 && !e.shiftKey) ){
          $active.removeClass('-selected');
          if( !$active.next().length ){
            $results.find('li').first().addClass('-selected');
          }
          else {
            $active.next().addClass('-selected');
          }

        }
        else if( e.keyCode == 13 && $active.length ){
          this.goToResult( $active.data('ref') );

        }
        else {
          ignore = true;
        }
        if( !ignore ){
          e.preventDefault();
          return;
        }
      }
      
    },
    
    onResultMouseenter : function(e){
      var $li = $(e.currentTarget);
      var $selected = $li.parent().find('.-selected');
      
      $selected.removeClass('-selected');
      $li.addClass('-selected');
    },
    
    onResultMouseleave : function(e){
      var $li = $(e.currentTarget);
      $li.removeClass('-selected');
    },
    
    onResultClick : function(e){
      var $li = $(e.currentTarget);
      this.goToResult($li.data('ref'));
    },
    
    goToResult : function(i){
      var $results = this.$results;
      setTimeout(function(){
        $results.hide();
      }, 10);
      var $node = $(this.questions[i].node);
      this.hash = $node.find('.'+this.ns+'__q a').attr('href');
      window.location.hash = this.hash;
      if( !$node.hasClass('-open') ){
      	$node.find('.'+this.ns+'__q a').click();
      }
      this.$search.find('input').blur();
      
      var top = $node.offset().top - $('body').offset().top;
      
      
      
      $('html,body').animate({
        scrollTop: top
      }, 400, function(){
        $node.find('.'+this.ns+'__q a').focus();
      });
    },
    
    hideResults : function(e){
      var $results = this.$results;
      setTimeout(function(){
      	$results.hide();
      },2000);
    },
    
    onHashChange : function(e){
      if( !window.location.hash ) return;
      if( this.hash == window.location.hash ) return;
      if( window.location.hash.substr(0,2) !== '#!' ) return;
      
      
      var id = window.location.hash.substr(2);
      if( this.ids[id] ){
        this.goToResult( this.ids[id] );
      }
    }
    
  });

  $(function(){
     window.rbFaq = new FAQ();
  });

})(jQuery);